import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	collapseCardLabel: {
		id: 'custom-sites-extensions.link-cards.card.collapse.label',
		defaultMessage: 'Collapse card',
		description: 'Label on chevron down icon for collapsing a card',
	},
	expandCardLabel: {
		id: 'custom-sites-extensions.link-cards.card.expand.label',
		defaultMessage: 'Expand card',
		description: 'Label on chevron right icon for expanding a card',
	},
	removeCardLabel: {
		id: 'custom-sites-extensions.link-cards.card.remove.card.label',
		defaultMessage: 'Remove card',
		description: 'Label on trash can icon for removing a card',
	},
	cardTitle: {
		id: 'custom-sites-extensions.link-cards.card.title',
		defaultMessage: 'Card {order}',
		description:
			'Title that serves as heading of collapsible card. When title is not given, defaults to Card number.',
	},

	// Items can be referred to as "cards" (link cards extension) or "frames" (carousel v2)
	collapseItemLabel: {
		id: 'custom-sites-extensions.shared-components.item.collapse.label',
		defaultMessage:
			'{itemLabel, select, card {Collapse card} frame {Collapse frame} other {Collapse card}}',
		description: 'Label on chevron down icon for collapsing an item (card or frame)',
	},
	expandItemLabel: {
		id: 'custom-sites-extensions.shared-components.item.expand.label',
		defaultMessage:
			'{itemLabel, select, card {Expand card} frame {Expand frame} other {Expand card}}',
		description: 'Label on chevron right icon for expanding an item (card or frame)',
	},
	removeItemLabel: {
		id: 'custom-sites-extensions.shared-components.item.remove.label',
		defaultMessage:
			'{itemLabel, select, card {Remove card} frame {Remove frame} other {Remove card}}',
		description: 'Label on trash can icon for removing an item (card or frame)',
	},
	itemTitle: {
		id: 'custom-sites-extensions.shared-components.item.title',
		defaultMessage:
			'{itemLabel, select, card {Card {order}} frame {Frame {order}} other {Card {order}}}',
		description:
			'Title that serves as heading of collapsible item (card or frame). When title is not given, defaults to {itemType} number.',
	},
});
